var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : $.noop;
var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var Modal = require('./modal.jsx');
var modalActions = require('../../../modules/modals/actions/modal');

var TutorialTourModal = createReactClass({

  $tutorialTourOrbit: null,
  $forwardBtn: null,
  $orbitBullets: null,

  componentDidMount: function(){
      this.$tutorialTourOrbit = $('#tutorialTourOrbit');
      this.$forwardBtn = this.$tutorialTourOrbit.find('.forward');
      this.$orbitBullets = this.$tutorialTourOrbit.find('.orbit-bullets');

      new Foundation.Orbit(this.$tutorialTourOrbit, {
          nextClass: 'forward',
          autoPlay: false,
          animInFromLeft: 'fade-in',
          animInFromRight: 'fade-in',
          animOutToLeft: 'fade-out',
          animOutToRight: 'fade-out'
      });

      $(window).on('changed.zf.mediaquery', this.mediaqueryChangedHandler);

      this.$tutorialTourOrbit.on('slidechange.zf.orbit', function(e, $newSlide){
          if($newSlide.hasClass('welcome')){
              this.$orbitBullets.css('opacity', '');
              this.$forwardBtn.text('Take the Tour');
          }else if($newSlide.hasClass('meet')){
              this.$forwardBtn.text('Again');
          }else{
              this.$forwardBtn.text('Continue');
              this.$orbitBullets.css('opacity', 1);
          }
      }.bind(this));
  },

  componentWillUnmount: function(){
      this.$tutorialTourOrbit.off('slidechange.zf.orbit');
      this.$tutorialTourOrbit.foundation('destroy');
      $(window).off('changed.zf.mediaquery', this.mediaqueryChangedHandler);
  },

  mediaqueryChangedHandler: function(e, curMQ, prevMQ){
      if(curMQ === 'small' || prevMQ === 'small'){
          this.onClose();
      }
  },

  onClose: function() {
    this.props.hideModal();
  },

  render: function() {
    var id = this.props.modal.props.id || 'tutorialTour';

    return (
      <Modal onClose={this.onClose} id={id}>
          <div id="tutorialTourOrbit" className="orbit" role="region" aria-label="Tutorial Tour">
              <h1 className="show-for-sr">Tutorial Tour</h1>
              <div className="orbit-wrapper">
                  <ul className="orbit-container">
                      <li className="welcome orbit-slide is-active">
                          <div className="img"></div>
                          <div className="text">
                              <h2>Welcome to MyGi</h2>
                              <p>In MyGi, you can track your daily symptoms, improve your quality of life and setup appointments with your doctor.</p>
                          </div>
                      </li>
                      <li className="monitor orbit-slide">
                          <div className="img"></div>
                          <div className="text">
                              <h2>Monitor Your Progress</h2>
                              <p>Better understand your symptoms, make educated FDA-approved treatment decisions and know when it’s time to see your doctor.</p>
                          </div>
                      </li>
                      <li className="improve orbit-slide">
                          <div className="img"></div>
                          <div className="text">
                              <h2>Improve Your Quality of Life</h2>
                              <p>Understand how your quality of life relates to your Gi symptoms, helping in your mission to get better and stay better.</p>
                          </div>
                      </li>
                      <li className="meet orbit-slide">
                          <div className="img"></div>
                          <div className="text">
                              <h2>Meet With Your Doc & Share Reports</h2>
                              <p>Schedule and prepare for your doctor’s visit while easily sharing the results of your symptom monitoring.</p>
                          </div>
                      </li>
                  </ul>
              </div>
              <nav className="orbit-bullets">
                  <button className="is-active" data-slide="0"><span className="show-for-sr">Welcome to MyGi</span><span className="show-for-sr">Current Slide</span></button>
                  <button data-slide="1"><span className="show-for-sr">Monitor Your Progress</span></button>
                  <button data-slide="2"><span className="show-for-sr">Improve Your Quality of Life</span></button>
                  <button data-slide="3"><span className="show-for-sr">Meet With Your Doc & Share Reports</span></button>
              </nav>
              <div className="actions">
                  <button className="forward button">Take the Tour</button>
                  <button className="gotcha button secondary" onClick={this.onClose}>No thanks, I got it</button>
              </div>
          </div>
          <div id="preload">
              <img src="" alt="" />
          </div>
      </Modal>
    );
  }

});

var mapDispatchToProps = function(dispatch) {
  return bindActionCreators(Object.assign({}, modalActions), dispatch);
}

module.exports = ReactRedux.connect(null, mapDispatchToProps)(TutorialTourModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/tutorialTourModal.jsx